export const VerifiedType = Object.freeze({
  NONE: 'NONE',
  APPLIED: 'APPLIED',
  INPROGRESS: 'INPROGRESS',
  ONHOLD: 'ONHOLD',
  VERIFIED: 'VERIFIED',
});